import React from 'react';

export type PageContainerVariant = 'default' | 'fullHeight' | 'tab';

export interface PageContainerProps {
  children: React.ReactNode;
  variant?: PageContainerVariant;
  className?: string;
}

/**
 * Standardized PageContainer enforcing full-width (w-full)
 * and unified vertical rhythm across all views.
 */
export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  variant = 'default',
  className = '',
}) => {
  let variantClasses = 'space-y-4';

  if (variant === 'fullHeight') {
    variantClasses = 'flex-1 flex flex-col min-w-0 max-w-full overflow-hidden min-h-0';
  } else if (variant === 'tab') {
    variantClasses = 'space-y-8 pb-6 min-w-0 max-w-full';
  }

  return (
    <div className={`w-full min-w-0 max-w-full ${variantClasses} ${className}`.trim()}>
      {children}
    </div>
  );
};
